// AI-ASSISTED: generated with claude-code on 2026-08-17, reviewed by Yoann Hertienne
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TileBoundary } from '../team-landing/TileBoundary';

// Backstage's built-in `metadata.links[]` field carries an optional `type`.
// Teams tag curated wiki links with `type: confluence`; this card surfaces
// exactly those, alongside the space-root ConfluenceCard (T052).
const CONFLUENCE_LINK_TYPE = 'confluence';

const ConfluenceLinksCardBody = () => {
  const { entity } = useEntity();
  const links = entity.metadata.links ?? [];
  const confluenceLinks = links.filter(link => link.type === CONFLUENCE_LINK_TYPE);

  // Hide the card entirely when the component curates no Confluence links —
  // truthful "no data" rather than an empty shell (spec FR-008).
  if (confluenceLinks.length === 0) return null;

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6">Confluence links</Typography>
        <List dense>
          {confluenceLinks.map((link, index) => {
            // Degrade gracefully when a team omits the title: fall back to the
            // raw URL so the entry stays clickable and accessibly named.
            const label = link.title?.trim() ? link.title : link.url;
            return (
              <ListItem key={`${link.url}-${index}`} disableGutters>
                <Link
                  href={link.url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Open ${label} in Confluence (opens in a new tab)`}
                >
                  {label}
                </Link>
              </ListItem>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
};

export const ConfluenceLinksCard = () => (
  <TileBoundary tool="Confluence links">
    <ConfluenceLinksCardBody />
  </TileBoundary>
);
